/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareDivide: {
  name: 'square-divide';
  data: string;
} = {
  name: 'square-divide',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><rect x="1" y="1" width="14" height="14" rx="1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 8h6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="11" r="1" fill="currentColor"/><circle cx="8" cy="5" r="1" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
